<template>
    <div>
        <form @submit.prevent="">
            <div class="form-group">
                <label for="frmPasswordChangeResetToken">{{ $t('pages.reset.reset_token') }}:</label>
                <input type="password" class="form-control" id="frmPasswordChangeResetToken"
                       placeholder="" v-model="resetToken">
            </div>
            <div class="form-group">
                <label for="frmPasswordChangeNew">{{ $t('pages.reset.new') }}:</label>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <div class="input-group-text" v-if="loading">
                            <i class="loader"></i>
                        </div>
                        <div class="input-group-text" v-if="!loading">
                            <i v-if="score.assessment">{{ score.assessment.days }}</i>
                            <i v-else>0</i>
                        </div>
                    </div>

                    <input type="password" class="form-control" id="frmPasswordChangeNew"
                           placeholder="" v-model="password">
                    <div class="input-group-append">
                        <div class="input-group-text" v-on:click="switchVisibility()">
                            <i class="fas fa-eye-slash" id="visibilityIcon"></i>
                        </div>
                    </div>
                </div>

                <small v-if="score" id="passwordScoreHelp"
                       class="form-text text-muted">{{ $t('pages.reset.score') }}: <strong>{{ score.score }}</strong>
                    <span
                        v-if="score.assessment">({{ $t('pages.reset.validity') }}:
                        <strong>{{ score.assessment.days }} {{ $t('pages.reset.days') }})</strong></span>
                </small>
            </div>

            <div class="form-group">
                <label for="frmPasswordChangeNew_confirmation">{{ $t('pages.reset.new_confirm') }}:</label>
                <input type="password" class="form-control" id="frmPasswordChangeNew_confirmation"
                       placeholder="" v-model='passwordConfirmation'>
                <small v-if="password !== passwordConfirmation">{{ $t('pages.reset.no_match') }}</small>
            </div>
            <button type="button"
                    class="btn btn-primary"
                    id="passwordChangeSubmit"
                    v-on:click="changePassword"
                    v-if="isSendable()">{{ $t('pages.reset.button_submit') }}
            </button>
        </form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            password: '',
            passwordConfirmation: '',
            resetToken: '',
            score: {},
            days: 0,
            error: {},
            message: '',
            hints: [],
            loading: false,
            notifications: []
        }
    },
    created() {
        this.errorHandler = this.$shared.errorHandlerForResponder;
    },
    mounted() {
        console.log('Mounted Reset.');

    },
    methods: {
        isSendable: function () {
            return this.password.length > 3 && (this.password === this.passwordConfirmation) && this.resetToken.length > 3 && this.score.assessment.days > 0;
        },
        switchVisibility: function () {
            let iconVisibility = $('#visibilityIcon');
            let passwordField = $('#frmPasswordChangeNew');

            switch (passwordField.attr('type')) {
                case 'text': {
                    passwordField.attr('type', 'password');
                    iconVisibility.toggleClass('fa-eye fa-eye-slash');
                    break;
                }
                case 'password': {
                    passwordField.attr('type', 'text');
                    iconVisibility.toggleClass('fa-eye-slash fa-eye');
                    break;
                }
            }
        },
    },
    computed: {

    }
};
</script>
